import React from "react";
import client from "directus/src/client";
import { useFetch } from "hooks/src/useFetch";
import { readRoles } from "@directus/sdk";
import { EvtSelect } from "components/select";

export default function SelectRole({
    value,
    onChange,
    className,
    placeholder = "Select Role",
    ...props
}) {
    const { data, isLoading } = useFetch({
        queryKey: ["roles"],
        queryFn: async () => {
            const result = await client.request(
                readRoles({
                    fields: ["id", "name"],
                    limit: -1,
                    sort: ["name"],
                })
            );

            return result.map((role) => ({
                id: role.id,
                name: role.name,
            }));
        },
    });

    const activeValue =
        typeof value === "object" && value !== null ? value.id : value;

    return (
        <EvtSelect
            data={data || []}
            isLoading={isLoading}
            value={activeValue}
            onChange={onChange}
            className={className}
            placeholder={placeholder}
            {...props}
        />
    );
}
